// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.pockie",
    name: "pockie",
    homepage: "https://www.pockie.io/ko",
    image_id: "a761beae-1e7e-4402-bcc5-a896a92bfb00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/kr/app/pockie/id6448715234",
        android: "https://play.google.com/store/apps/details?id=com.pilab.pockie&hl=en-KR",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "pockie://",
        universal: "https://pockie.app.link",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map